<template>
  <v-layout row justify-space-between align-center>
    <slot />
  </v-layout>
</template>

<script>
export default {
  name: "ObjectFormActivitiesTabNavbar"
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesTabNavbar.vue